import { render, staticRenderFns } from "./product-swiper-cd.vue?vue&type=template&id=69c7bc4a&scoped=true&"
import script from "./product-swiper-cd.vue?vue&type=script&lang=js&"
export * from "./product-swiper-cd.vue?vue&type=script&lang=js&"
import style0 from "./product-swiper-cd.vue?vue&type=style&index=0&id=69c7bc4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c7bc4a",
  null
  
)

export default component.exports